import { AnnouncementBar } from '@clickguard/design-system'
import { BlackFridayBackdrop } from './black-friday-banner'

export const BLACK_FRIDAY_OFFER_URL =
	'https://docs.clickguard.com/en/articles/26489-black-friday-presale-2026'

export const NewSubscriptionBanner = ({
	open,
	onHeightChange
}: {
	open: boolean
	onHeightChange?: (height: number) => void
}) => (
	<AnnouncementBar
		open={open}
		aria-label="Black Friday offer"
		label="Black Friday · Pre-sale"
		backdrop={<BlackFridayBackdrop />}
		onHeightChange={onHeightChange}
	>
		Select annual and get <s className="opacity-60">20%</s>{' '}
		<strong className="font-medium">35% off</strong> your first year, plus 3x ad
		spend limits through Q4.{' '}
		<a href={BLACK_FRIDAY_OFFER_URL} target="_blank" rel="noopener noreferrer">
			See offer details
		</a>
	</AnnouncementBar>
)
